"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderWrapper = exports.DateAndTypeWrapper = exports.AnnouncementTypeWrapper = exports.AnnouncementBody = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours
} = _uiKit.theme;
const DateAndTypeWrapper = exports.DateAndTypeWrapper = _styledComponents.default.div.withConfig({
  displayName: "Itemstyle__DateAndTypeWrapper",
  componentId: "sc-1ged6rf-0"
})(["display:flex;justify-content:space-between;margin-bottom:5px;align-items:center;"]);
const HeaderWrapper = exports.HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "Itemstyle__HeaderWrapper",
  componentId: "sc-1ged6rf-1"
})(["margin-top:5px;"]);
const AnnouncementBody = exports.AnnouncementBody = (0, _styledComponents.default)(HeaderWrapper).withConfig({
  displayName: "Itemstyle__AnnouncementBody",
  componentId: "sc-1ged6rf-2"
})([""]);
const AnnouncementTypeWrapper = exports.AnnouncementTypeWrapper = _styledComponents.default.div.withConfig({
  displayName: "Itemstyle__AnnouncementTypeWrapper",
  componentId: "sc-1ged6rf-3"
})(["", ";"], props => props.isCorrection && "\n      background: ".concat(colours.DISCONTINUED, ";\n      border-radius: 2px;\n      padding: 1.5px 3px 2.5px;\n      display: inline-block;\n      h6 {color: white;}\n    "));